// src/components/SEO.jsx
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, image, type }) => {
  return (
    <Helmet>
      {/* Standard metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* OpenGraph metadata */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />


    </Helmet>
  );
};

export default SEO;